import { styled } from '@mui/material';

export const Wrapper = styled('div')({
  width: '100%',
});

export const Title = styled('h2')({
  fontSize: 24,
  fontWeight: 700,
  margin: 0,
});

export const Placeholder = styled('div')({
  padding: '16px',
  color: '#666',
});

export const TableWrap = styled('div')({
  border: '1px solid #e4e4e4',
  borderRadius: 8,
  overflowX: 'auto',
});

export const StyledTable = styled('table')({
  width: '100%',
  tableLayout: 'fixed',
  borderCollapse: 'collapse',
  background: '#fff',
});

export const colWidths = {
  activityType: '120px',
  trackingType: '120px',
  activity: '140px',
  comments: 'auto',
  startTime: '155px',
  duration: '130px',
  endTime: '120px',
  actions: '132px',
};

export const HeaderCell = styled('th')({
  textAlign: 'left',
  borderBottom: '1px solid #d9d9d9',
  padding: '10px 12px',
  fontWeight: 600,
  fontSize: '13px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const BodyCell = styled('td')({
  borderBottom: '1px solid #efefef',
  padding: '10px 12px',
  fontSize: '13px',
  verticalAlign: 'top',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const EditInput = styled('input')({
  fontSize: '13px',
  padding: '4px 8px',
  border: '1px solid #d0d0d0',
  borderRadius: 4,
  width: '100%',
  boxSizing: 'border-box',
  '&:focus': {
    outline: 'none',
    borderColor: '#1976d2',
  },
});

export const EditSelect = styled('select')({
  fontSize: '13px',
  padding: '4px 8px',
  border: '1px solid #d0d0d0',
  borderRadius: 4,
  width: '100%',
  boxSizing: 'border-box',
  background: '#fff',
  '&:focus': {
    outline: 'none',
    borderColor: '#1976d2',
  },
});

export const ActionButton = styled('button')<{ $variant: 'edit' | 'save' | 'cancel' | 'delete' | 'reset' }>(
  ({ $variant, theme }) => ({
    fontSize: '12px',
    padding: 0,
    width: 30,
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: 'none',
    cursor: 'pointer',
    marginRight: 6,
    fontWeight: 500,
    ...($variant === 'edit' && {
      background: theme.palette.novotalk.$actionButtonColor,
      color: theme.palette.novotalk.$textColorReversed,
      '&:hover': { background: theme.palette.novotalk.$actionButtonColorHover },
      '&:active': { background: theme.palette.novotalk.$actionButtonColorActive },
    }),
    ...($variant === 'save' && {
      background: theme.palette.novotalk.$ctaButtonColor,
      color: theme.palette.novotalk.$textColorReversed,
      '&:hover': { background: theme.palette.novotalk.$ctaButtonColorHover },
      '&:active': { background: theme.palette.novotalk.$ctaButtonColorActive },
      '&:disabled': {
        background: theme.palette.novotalk.$buttonColorDisabled,
        color: theme.palette.novotalk.$textColorReversed,
        cursor: 'default',
      },
    }),
    ...($variant === 'cancel' && {
      background: theme.palette.novotalk.$secondaryButtonColor,
      color: theme.palette.novotalk.$textColorReversed,
      '&:hover': { background: theme.palette.novotalk.$secondaryButtonColorHover },
      '&:active': { background: theme.palette.novotalk.$secondaryButtonColorActive },
      '&:disabled': {
        background: theme.palette.novotalk.$buttonColorDisabled,
        color: theme.palette.novotalk.$textColorReversed,
        cursor: 'default',
      },
    }),
    ...($variant === 'delete' && {
      background: theme.palette.novotalk.$errorColor,
      color: theme.palette.novotalk.$textColorReversed,
      '&:hover': { opacity: 0.9 },
      '&:active': { opacity: 1 },
    }),
    ...($variant === 'reset' && {
      background: theme.palette.novotalk.$secondaryButtonColor,
      color: theme.palette.novotalk.$textColorReversed,
      '&:hover': { opacity: 0.9 },
      '&:active': { opacity: 1 },
    }),
    '&:disabled': { opacity: 0.5, cursor: 'default' },
  }),
);

export const datePickerSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    fontSize: '13px',
    fontFamily: 'inherit',
    padding: '4px 8px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d0d0d0',
      borderWidth: '1px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d0d0d0',
      borderWidth: '1px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
      borderWidth: '1px',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '13px',
    fontFamily: 'inherit',
    padding: 0,
    boxSizing: 'border-box',
  },
  '& .MuiInputAdornment-root': {
    marginLeft: 0,
  },
  '& .MuiIconButton-root': {
    padding: 0.5,
    marginRight: '-7px',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
  },
};

export const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d0d0d0',
      borderWidth: '1px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d0d0d0',
      borderWidth: '1px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
      borderWidth: '1px',
    },
    padding: '4px 8px',
    fontSize: '13px',
    fontFamily: 'inherit',
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '13px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  '& .MuiOutlinedInput-inputMultiline': {
    fontSize: '13px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
};
